import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { createBrowserHistory } from "history";
import appReducer from "./features/app/appSlice";
import storage from "redux-persist/lib/storage";
import { persistReducer, persistStore } from "redux-persist";
import patientReducer from "./features/patient/patientSlice";
import assessmentReducer from "./features/patient/assessmentsSlice";
import bhiReducer from "./features/patient/bhiSlice";
import pinnedContentReducer from "./features/patient/pinnedContentSlice";
import chatReducer from "./features/chat/chatSlice";
import opsReducer from "./features/ops/opsSlice";
const history = createBrowserHistory();
const persistConfig = {
  key: "rose",
  storage,
};

const combinedReducer = combineReducers({
  app: appReducer,
  patient: patientReducer,
  assessment: assessmentReducer,
  bhi: bhiReducer,
  pinnedContent: pinnedContentReducer,
  chat: chatReducer,
  ops: opsReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "app/logoutUser") {
    state = undefined;
  }
  if (state && state.analytics) {
    delete state.analytics;
  }

  return combinedReducer(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);
export const store = configureStore(
  {
    reducer: persistedReducer,
    devTools: process.env.NODE_ENV !== "production",
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({ serializableCheck: false, immutableCheck: false }),
  },
  history
);

export const persistor = persistStore(store);
